const drawerDetailsWidth = 600;
export const layoutIdentifySupplierJobsStyle = (theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    zIndex: theme.zIndex.drawer + 1,
    boxShadow: "1px 1px 3px #d3d3d3",
  },
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  appBarSpacer: theme.mixins.toolbar,
  drawerDetailsPaper: {
    background: "#F1F3F4",
    border: "1px solid #979797",
    margin: "0px",
    padding: "0px",
    whiteSpace: "nowrap",
    width: drawerDetailsWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  alert: {
    whiteSpace: "pre-line",
  },
});
